var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/index.ts
function extractIdFromUrl(url) {
  const result = /[\w\-]+$/.exec(url);
  return result ? result[0] : "";
}
function getBoxRenderers() {
  return {
    hr: () => ({
      tagName: "div",
      attributes: {
        class: "lake-box-block lake-hr"
      },
      innerHTML: "<hr />"
    }),
    image: (boxValue) => ({
      tagName: "img",
      attributes: __spreadProps(__spreadValues(__spreadValues(__spreadValues({
        src: boxValue.url
      }, boxValue.width && { width: boxValue.width }), boxValue.height && { height: boxValue.height }), boxValue.caption && { alt: boxValue.caption }), {
        border: "0"
      }),
      isVoid: true
    }),
    media: (boxValue) => ({
      tagName: "video",
      attributes: __spreadProps(__spreadValues(__spreadValues({
        src: boxValue.url
      }, boxValue.width && { width: boxValue.width.replace(/px$/i, "") }), boxValue.height && { height: boxValue.height.replace(/px$/i, "") }), {
        controls: "true"
      })
    }),
    file: (boxValue, encode) => ({
      tagName: "a",
      attributes: {
        href: boxValue.url,
        target: "_blank"
      },
      innerHTML: encode(boxValue.name)
    }),
    codeBlock: (boxValue, encode) => ({
      tagName: "pre",
      attributes: {
        class: `lang-${boxValue.lang}`
      },
      innerHTML: `<code>${encode(boxValue.code)}</code>`
    }),
    emoji: (boxValue) => ({
      tagName: "img",
      attributes: {
        src: boxValue.url,
        width: "32",
        height: "32",
        border: "0"
      },
      isVoid: true
    }),
    equation: (boxValue) => ({
      tagName: "code",
      innerHTML: boxValue.code
    }),
    mention: (boxValue, encode) => {
      var _a;
      return {
        tagName: "a",
        attributes: {
          href: `/${boxValue.name}`,
          target: "_blank"
        },
        innerHTML: encode((_a = boxValue.nickname) != null ? _a : boxValue.name)
      };
    },
    video: (boxValue) => ({
      tagName: "iframe",
      attributes: __spreadProps(__spreadValues({}, boxValue.url && { src: `https://www.youtube.com/embed/${extractIdFromUrl(boxValue.url)}` }), {
        width: boxValue.width ? boxValue.width.replace(/px$/i, "") : "560",
        height: boxValue.height ? boxValue.height.replace(/px$/i, "") : "315",
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: "true"
      })
    }),
    twitter: (boxValue) => ({
      tagName: "iframe",
      attributes: __spreadProps(__spreadValues({}, boxValue.url && { src: `https://platform.twitter.com/embed/Tweet.html?id=${extractIdFromUrl(boxValue.url)}` }), {
        title: "Twitter tweet",
        scrolling: "no",
        frameborder: "0",
        allowtransparency: "true",
        allowfullscreen: "true",
        style: "width: 550px; height: 300px;"
      })
    })
  };
}
var htmlEntityMap = /* @__PURE__ */ new Map([
  ["&", "&amp;"],
  ["<", "&lt;"],
  [">", "&gt;"],
  ['"', "&quot;"],
  ["\xA0", "&nbsp;"]
]);
function encodeHTMLEntities(value) {
  return value.replace(/[&<>"\xA0]/g, (match) => htmlEntityMap.get(match));
}
function decodeBase64(value) {
  const binaryString = atob(value);
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }
  const decoder = new TextDecoder();
  return decoder.decode(byteArray);
}
function parseAttributes(tag) {
  const attributes = {};
  const reg = /\s+(?:([\w\-:]+)=([^\s"'<>]+)|([\w\-:"]+)="([^"]*)"|([\w\-:"]+)='([^']*)')(?=[\s/>])/g;
  let match;
  while (match = reg.exec(tag)) {
    const key = (match[1] || match[3] || match[5]).toLowerCase();
    const value = match[1] ? match[2] : match[3] ? match[4] : match[6];
    attributes[key] = value;
  }
  return attributes;
}
function serializeAttributes(attrs) {
  const result = [];
  for (const key of Object.keys(attrs)) {
    const value = String(attrs[key]);
    result.push(`${key}="${encodeHTMLEntities(value)}"`);
  }
  return result.join(" ");
}
function toBoxHTML(node) {
  var _a;
  let result = `<${node.tagName}`;
  if (node.attributes) {
    result += ` ${serializeAttributes(node.attributes)}`;
  }
  if (node.isVoid === true) {
    result += " />";
  } else {
    result += `>${(_a = node.innerHTML) != null ? _a : ""}</${node.tagName}>`;
  }
  return result;
}
function toHTML(value, renderers) {
  renderers = renderers != null ? renderers : getBoxRenderers();
  const combinedRegex = /(<lake-box[^>]+>)[\s\S]*?(?:<\/lake-box>|$)|(<anchor\s*\/>)|(<focus\s*\/>)/gi;
  return value.replace(combinedRegex, (match, boxOpen) => {
    if (boxOpen) {
      const attributes = parseAttributes(boxOpen);
      const render = renderers[attributes.name];
      if (render) {
        try {
          const boxValue = attributes.value ? JSON.parse(decodeBase64(attributes.value)) : {};
          const node = render(boxValue, encodeHTMLEntities);
          return toBoxHTML(node);
        } catch (e) {
          console.error("Failed to parse lake-box value:", e);
        }
      }
    }
    return "";
  });
}
export {
  getBoxRenderers,
  toHTML
};
//# sourceMappingURL=index.mjs.map